import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminTable from 'common/AdminTable';
import { getRequest, deleteRequest } from 'apis/ApiInstence';
import { FaTrash, FaEdit } from 'react-icons/fa';

const MainCategoryList = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const res = await getRequest('main-categories');
      setData(res?.data || []);
    } catch (err) {
      console.error('Failed to fetch main categories:', err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRemove = async (id) => {
    if (!window.confirm('Are you sure you want to delete this main category?')) return;
    try {
      await deleteRequest(`main-categories/${id}`);
      fetchData();
    } catch (err) {
      console.error('Failed to delete main category:', err);
    }
  };

  const tableHeaders = [
    { Header: 'Name', accessor: 'name' },
    { Header: 'Status', accessor: 'status' },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#ffc107' }}
            onClick={() => navigate(`/main-categories/update/${row.original.id}`)}
          >
            <FaEdit />
          </button>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#dc3545' }}
            onClick={() => handleRemove(row.original.id)}
          >
            <FaTrash />
          </button>
        </>
      )
    }
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Main Category List</h4>
      </div>
      <div className="mx-4">
        {data?.length ? (
          <AdminTable tableHeaders={tableHeaders} tableData={data} />
        ) : (
          <p>No main categories available.</p>
        )}
      </div>
    </div>
  );
};

export default MainCategoryList;
